import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgIHerbLeaf({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.152 3.008l.503.026.253.02.79.084.097.79.07.689.034.43c.144 1.951.152 4.021-.068 5.977-.157 1.4-.426 2.657-.826 3.736-2.206 5.952-7.71 6.573-11.795 3.851-1.153 1.598-2.432 2.544-3.958 2.368-1.567-.18-2.078-.84-2.225-1.634-.117-.636.14-1.2.809-1.271 1.221-.13.773.937 2.172.978.814.024 1.635-.571 2.238-1.166l-.036-.022c-1.136-.771-2.219-2.713-2.581-4.694-.49-2.683.305-5.16 2.607-6.785.8-.566 1.648-1.057 2.536-1.477 3.23-1.528 6.564-2.007 9.38-1.9zm-8.524 3.708c-.786.372-1.534.805-2.238 1.302-1.612 1.138-2.154 2.825-1.794 4.792.274 1.498 1.106 2.97 1.7 3.377l.235.148.794.618c3.093 2.09 7.12 1.655 8.805-2.888.337-.91.573-2.013.713-3.265.179-1.587.195-3.281.106-4.912l-.045-.694L18.89 5c-2.485-.067-5.438.379-8.261 1.715z"
        fill={color}
      />
    </svg>
  )
}

export default SvgIHerbLeaf
